<template>
  <SSectionSplit
    :title="t('views.cottage.keepSearching.title')"
    background-color="primary-900"
    :url="item.province.url"
  >
    <SCtaColorImage
      :button-text="t('views.cottage.keepSearching.button')"
      :link="routes().cottageProvince({ slug: item.province.slug })"
      @button-click="sendGa4CtaClickEvent()"
    ></SCtaColorImage>
  </SSectionSplit>
</template>
<script setup lang="ts">
import type { CottagePage } from '../entities/CottagePage'
import { sendGa4KeepSearchEvent } from '~~/modules/integrations/ga4/composables/useAnalyticsGa4Composable'

type itemType = Pick<CottagePage, 'province'>

interface propsInterface {
  item: itemType
}

defineProps<propsInterface>()

const sendGa4CtaClickEvent = () => {
  sendGa4KeepSearchEvent()
}
</script>
